/**
 * This component displays if documents are missing
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-document-missing-message',
  templateUrl: './document-missing-message.component.html',
  styleUrls: ['./document-missing-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, TranslatePipe]
})
export class DocumentMissingMessageComponent {
}
